module.exports = {
    env: {
      ENVM: process.env.ENVM,
      BASE: '/'
    },
    confEnv: {
      baseURL:   process.env.NODE_ENV === 'development' ? '/api' : '/api',
      baseURL2:  process.env.NODE_ENV === 'development' ? '/honda-pc' : 'http://pc.dongfeng-honda.com',
      baseURL3:  process.env.NODE_ENV === 'development' ? '/api' : 'http://shop-be.dongfeng-honda.com'
    },
    confWp:{
      publicPath:  process.env.NODE_ENV === 'development' ? '/' : '/', // 基本路径
      outputDir:  process.env.NODE_ENV === 'development' ? 'sanyiusa' : 'sanyiusa' // 输出文件目录
    },
    qiankuan: {
      subShop: {
        entry: process.env.NODE_ENV === 'development' ? 'http://localhost:5501' : 'http://shop-fe.dongfeng-honda.com'
      }
    },
    proxy: {
      '/sanyiusa/honda-pc/data/business_report': {
        target: 'http://pc.dongfeng-honda.com',
        changeOrigin: true,
        pathRewrite: {
           '^/sanyiusa/honda-pc/data/business_report': '/honda-pc/data/business_report'
        }
        },
        '/gateway': {
          target: 'http://admin-oommc-uat.sanyglobal.com',
          changeOrigin: true
        }
     }
}